import React from "react";

// Icono de cada componente, para las cabeceras de las filas (FichaLlave,
// Info de llave, Info de piso).
export const ICONO_COMPONENTE = { portal: "🚪", piso: "🏠", buzon: "📮" };

const MECANISMOS = [
  ["fisica", "🗝️", "Física"],
  ["magnetica", "🧲", "Magnética"],
  ["ambas", "🗝️🧲", "Ambas"],
];

// Campos de mecanismo/tarjeta/seguridad de UN componente (portal/piso/buzón)
// de una llave — compartido por Admin>Inventario>Info, Rutas>Preparar y
// Prestar, para que la regla de negocio no diverja entre los tres sitios:
//   - 'ambas' (física + magnética) solo existe en 'portal'.
//   - 'buzon' es siempre física, sin tarjeta ni seguridad (así lo impone
//     también la BBDD, ver chk_buzon_simple en el esquema).
// `valor` = {mec, tarj, seg}; `onChange(campo, valor)` para cada cambio.
export default function ComponenteCampos({ tipo, valor, onChange }) {
  if (tipo === "buzon") {
    return (
      <div className="componente-row-body">
        <span className="cc-fijo">🗝️ Siempre física · sin tarjeta ni seguridad</span>
      </div>
    );
  }
  const opciones = MECANISMOS.filter(([m]) => m !== "ambas" || tipo === "portal");
  return (
    <div className="componente-row-body">
      <div className="cc-mec" role="radiogroup" aria-label="Mecanismo">
        {opciones.map(([m, ico, txt]) => (
          <button key={m} type="button" role="radio" aria-checked={valor.mec === m}
                  className={valor.mec === m ? "on" : ""} onClick={() => onChange("mec", m)}>
            <span>{ico}</span> {txt}
          </button>
        ))}
      </div>
      <div className="cc-extras">
        <button type="button" className={`cc-chip ${valor.tarj ? "on" : ""}`} aria-pressed={!!valor.tarj}
                onClick={() => onChange("tarj", !valor.tarj)}>
          💳 Tarjeta {valor.tarj ? "✓" : ""}
        </button>
        <button type="button" className={`cc-chip seg ${valor.seg ? "on" : ""}`} aria-pressed={!!valor.seg}
                onClick={() => onChange("seg", !valor.seg)}>
          🔒 Seguridad {valor.seg ? "✓" : ""}
        </button>
      </div>
    </div>
  );
}
